import React, { useContext, useEffect } from "react"
import PropTypes from "prop-types"
import SubscriptionContext from "context/subscription/subscriptionContext"
import { Container } from "reactstrap"
import SubscriptionComponent from "components/GestionEmpresa/subscriptionComponent"
import { Box, Typography, Stack } from "@mui/material"
import i18n from "i18n"
import { GRANTED } from "constants/entitlements"
import { subscriptionHasEnabledFeature } from "utils/subscriptionEntitlements"

const EntitlementPageGuard = ({ children, permission }) => {
  const { subscriptionState } = useContext(SubscriptionContext)

  const isLoading =
    !subscriptionState ||
    !Array.isArray(subscriptionState.subscription_entitlements)
  const hasPermission =
    permission === GRANTED ||
    subscriptionHasEnabledFeature(subscriptionState, permission)

  if (isLoading) {
    return <>{children}</>
  }

  if (!hasPermission) {
    return (
      <Box pt={5} sx={{ marginTop: "50px" }}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={3}
        >
          <Typography variant="h5" align="center">
            {i18n.t("entitlements.updateYourPlan")}
          </Typography>
          <Container
            fluid
            style={{ padding: "30px 0 0", background: "#f2f2f2" }}
          >
            <SubscriptionComponent anual={false} setAnual={false} />
          </Container>
        </Stack>
      </Box>
    )
  }

  return <>{children}</>
}

EntitlementPageGuard.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string.isRequired,
}

export default EntitlementPageGuard
